import React from 'react'
import Layout from '../../component/Layout';
import FeatureDetail from '../../component/FeatureDetail';
import { useParams } from 'react-router-dom';
import { t } from 'i18next';

const FeaturesDetailContainer = () => {
	const { id } = useParams();
	return (
		<Layout title={t(`${id}`)} description={t("features_desc")}>
			<FeatureDetail />
		</Layout>
	)
}

export default FeaturesDetailContainer